import script from "./KbsCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./KbsCenter.vue?vue&type=script&setup=true&lang=js"

import "./KbsCenter.vue?vue&type=style&index=0&id=162b354a&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-162b354a"]])

export default __exports__